module.exports = __webpack_public_path__ + "images/3ce834b68bc9ad9d3e87392820ddf078-Monterey.png";